/**
 * I paesi per i dati di fatturazione: tutti (ISO 3166-1), con il nome in
 * italiano che da' il browser. Prima c'era una lista di 23: un cliente della
 * Guyana francese o della Finlandia non trovava il suo paese.
 */

const CODICI = (
  "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ " +
  "CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR " +
  "GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO " +
  "JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR " +
  "MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO " +
  "RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV " +
  "TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW"
).split(" ");

// I paesi UE: con la loro partita IVA la vendita e' in inversione contabile.
// La stessa lista e' sul server (apps/api/src/services/billingProfile.js).
export const PAESI_UE = [
  "AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GR", "HR", "HU",
  "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK",
];

/** Il prefisso della partita IVA: la Grecia usa EL, non GR. */
export const prefissoIva = (paese) => (paese === "GR" ? "EL" : paese);

export function nomePaese(codice) {
  try {
    return new Intl.DisplayNames(["it"], { type: "region" }).of(codice) || codice;
  } catch {
    return codice;
  }
}

/** Il menu: Italia per prima, poi tutti in ordine alfabetico italiano. */
export const PAESI = [
  "IT",
  ...CODICI.filter((c) => c !== "IT").sort((a, b) => nomePaese(a).localeCompare(nomePaese(b), "it")),
];
